/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import NDCByDrugName from './component/NDCByDrugName/NDCByDrugName';
import NDCByID from './component/NDCByID/NDCByID';
import NDCByLabeler from './component/NDCByLabeler/NDCByLabeler';
import NDCTabs from './component/NDCTabs';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import { getAllNDCReferenceData, setNDCSelectedNDCTab } from './store/action';
import { NDC_TABS_DATA } from './utility/constants';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import { handleScrollToEvent } from '../../../SharedModules/CommonUtilities/commonUtilities';

const NDC = () => {
  const dispatch = useDispatch();
  const selectedNDCTab = useSelector(
    (state) => state.sharedState.ndc.selectedNDCTab
  );

  const userDefaults = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );

  const errorPopupMessage = useSelector(
    (state) => state.sharedState.ndc.errorPopupMessage
  );

  const loading = useSelector((state) => state.sharedState.ndc.loading);
  const [fullScreen, setFullScreen] = useState(false);

  useEffect(() => {
    dispatch(getAllNDCReferenceData());
    handleScrollToEvent();
    const ele = document.querySelector('.nav-item-active a .tab-title');
    if (ele) {
      ele.textContent = 'Select NDC for Display';
    }
  }, []);

  useEffect(() => {
    const tabExists = NDC_TABS_DATA.some((tab) => tab.value === selectedNDCTab);

    if (!tabExists) {
      if (userDefaults && userDefaults.defNdcSelectModeCd) {
        dispatch(
          setNDCSelectedNDCTab(
            NDC_TABS_DATA[
              userDefaults.defNdcSelectModeCd === 'NDC'
                ? 0
                : userDefaults.defNdcSelectModeCd === 'LABELER'
                ? 2
                : 1
            ].value
          )
        );
      } else {
        dispatch(setNDCSelectedNDCTab(NDC_TABS_DATA[1].value));
      }
    }
  }, [selectedNDCTab, userDefaults]);

  return (
    <>
      <div className="tabs-container">
        {loading && <Spinner load={loading} />}
        {errorPopupMessage && (
          <DisplayErrorMessages errorMessages={[errorPopupMessage]} />
        )}
        <CustomSeparator parent1="Display" parent2="NDC" />
        {!fullScreen && (
          <NDCTabs selectedTab={selectedNDCTab} tabData={NDC_TABS_DATA} />
        )}
        {selectedNDCTab === NDC_TABS_DATA[0].value ? (
          <NDCByID fullScreen={fullScreen} setFullScreen={setFullScreen} />
        ) : selectedNDCTab === NDC_TABS_DATA[1].value ? (
          <NDCByDrugName
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
          />
        ) : (
          <NDCByLabeler fullScreen={fullScreen} setFullScreen={setFullScreen} />
        )}
      </div>
    </>
  );
};

export default NDC;
